export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon-sub-menu-back.5d95f9eb.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};